
import React from "react";
import { AgencyLogo } from "../atoms/AgencyLogo";
import styled from "styled-components";

export const SecondBus = (props) => {
  const { stoptime, color } = props;
  if (stoptime === undefined) return <div></div>;

  const stopHeadsignLength = stoptime.stop_headsign.length;
  const stopHeadsignEnLength = stoptime.stop_headsign_en ? stoptime.stop_headsign_en.length: stoptime.stop_headsign.length;
  let stopHeadsignFontSize = "15px";
  let stopHeadsignFontSize_en = "14px";

  if (stopHeadsignLength < 20) {
    stopHeadsignFontSize = "26px";
  } else if (stopHeadsignLength < 25) {
    stopHeadsignFontSize = "22px";
  } else if (stopHeadsignLength < 30) {
    stopHeadsignFontSize = "22px";
  } else if (stopHeadsignLength < 35) {
    stopHeadsignFontSize = "18px";
  } else {
    /*40文字まではOK*/
    stopHeadsignFontSize = "15px";
  }

  if (stopHeadsignEnLength < 40) {
    stopHeadsignFontSize_en = "18px";
  } else if (stopHeadsignEnLength < 45) {
    stopHeadsignFontSize_en = "16px";
  } else if (stopHeadsignEnLength < 50) {
    stopHeadsignFontSize_en = "16px";
  } else {
    stopHeadsignFontSize_en = "14px";
  }

  const routeNameLength = stoptime.route_short_name.length;
  let routeNameFontSize = "12px";
  if (routeNameLength < 5) {
    routeNameFontSize = "26px";
  } else {
    if (routeNameLength < 7) {
      routeNameFontSize = "16px";
    } else {
      if (routeNameLength >= 7) {
        routeNameFontSize = "12px";
      } else {
      }
    }
  }
  return (
    <SContainer>
      <SRoute color={color} fontSize={routeNameFontSize}>
        <div>{stoptime.route_short_name}</div>
      </SRoute>
      <SNext>
        <SJa fontSize={stopHeadsignFontSize}>{stoptime.stop_headsign}</SJa>
        <SEn fontSize={stopHeadsignFontSize_en}>{stoptime.stop_headsign_en}</SEn>
      </SNext>
      <SClock>{stoptime.departure_time}</SClock>
      <SOpe>
        <AgencyLogo agencyId={stoptime.agency_id} />
      </SOpe>
    </SContainer>
  );
};

const SContainer = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  margin: 0px;
  padding: 0px;
  height: 68.5px;
`;

const SBase = styled.div``;

const SRoute = styled(SBase)`
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    display: flex;
    font-weight: 500;
    justify-content: center;
    align-items: center;
    font-size: ${(props) => props.fontSize};
    height: 45px;
    width: 72px;
    color: white;
    background-color: ${(props) => props.color};
  }
`;
const SNext = styled(SBase)`
  text-align: left;
  margin-left: 5px;
  width: calc(100% - 320px);
`;

const SJa = styled.div`
  display: flex;
  align-items: center;
  list-style: none;
  height: 35px;
  letter-spacing: -2px;
  font-size: ${(props) => props.fontSize};
`;

const SEn = styled.div`
  display: flex;
  align-items: center;
  list-style: none;
  height: 20px;
  letter-spacing: 0px;
  font-size: ${(props) => props.fontSize}
`;

const SClock = styled(SBase)`
  width: 100px;
  font-size: 32px;
`;
const SOpe = styled(SBase)`
  width: 120px;
`;
